import { render, staticRenderFns } from "./EmailSearchPage.vue?vue&type=template&id=9b0afea8&scoped=true&"
import script from "./EmailSearchPage.vue?vue&type=script&lang=ts&"
export * from "./EmailSearchPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmailSearchPage.vue?vue&type=style&index=0&id=9b0afea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0afea8",
  null
  
)

export default component.exports